import React from "react";
import { setTitle } from "../../helpers/MetaTag";
import DashboardCount from "../../components/sections/admin/dashboard/DashboardCount";
import DashboardNewsLists from "../../components/sections/admin/dashboard/DashboardNewsLists";
import { useGetPermission } from "../../hooks/useGetPermission";

const Dashboard = () => {
  setTitle("Vpeters Admin | Dashboard");
  const { permission, status } = useGetPermission("dashboard");

  return (
    <div className="space-y-8">
      {!permission?.list ? (
        <div className="h-[calc(100vh-50px)] w-full flex items-center justify-center">
          <span className="text-center text-xl font-medium">
            Access denied. Please contact admin for help.
          </span>
        </div>
      ) : (
        <>
          <DashboardCount />
          <DashboardNewsLists />
        </>
      )}
    </div>
  );
};

export default Dashboard;
